module.exports = __webpack_public_path__ + "static/media/prize-header.a4509e08.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/user-new/prize-header.png
// module id = 316
// module chunks = 0